import styled from "styled-components";

const ProductsListStyles = styled.div`
  width: fit-content;
  padding: 0px 8px;
  background-color: #cccccc;
  border-radius: 2px;
  margin-right: 10px;
  float: left;
`;
export default ProductsListStyles;
